import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'

@observer
export default class AddAiQuestion extends Component {
    constructor(props) {
        super(props)
        const { store } = this.props
        this.appStore = store
    }

    close = (e) => {
        e?.preventDefault()
        this.appStore.aiQuestions.addModalOpen = false
    }

    continue = (e) => {
        e.preventDefault()
        this.appStore.aiQuestions.add()
        this.close()
    }

    render() {
        return (
            <Modal
                show={this.appStore.aiQuestions.addModalOpen}
                onClose={this.close}
            >
                <div id="add-ai-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('surveyBuilder.modal.addAiConfirmation.title')}</h2>
                        <p className="uc-modal__desc">
                            {i18n.t('surveyBuilder.modal.addAiConfirmation.desc.pt1')}
                        </p>
                        <p className="uc-modal__desc">
                            {i18n.t('surveyBuilder.modal.addAiConfirmation.desc.pt2')}
                        </p>
                    </div>
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.close}
                            cssClass="tertiary"
                            label={i18n.t('cancel')}
                        />
                        <Button
                            onClick={this.continue}
                            cssClass="secondary"
                            label={i18n.t('continue')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
